import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Dashboard from './components/Dashboard';
import Settings from './components/Settings';
import PostList from './components/PostList';
import Layout from './components/Layout';
import Login from './components/Login';
import ForgotPassword from './components/ForgotPassword';
import Users from './components/Users';
import CommentListPage from './components/CommentListPage';
import AIResponsePage from './components/AIResponsePage';

import RequireAuth from './components/RequireAuth';
import ProtectedRoute from './components/ProtectedRoute';

const App: React.FC = () => {
    return (
        <Router future={{ 
            v7_startTransition: true,
            v7_relativeSplatPath: true 
        }}>
            <Routes>
                {/* Public Routes */}
                <Route path="/login" element={<Login />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />

                {/* Protected Routes */}
                <Route path="/" element={
                    <RequireAuth>
                        <ProtectedRoute requiredPermission="dashboard">
                            <Layout>
                                <Dashboard />
                            </Layout>
                        </ProtectedRoute>
                    </RequireAuth>
                } />
                <Route path="/posts" element={
                    <RequireAuth>
                        <Layout>
                            <PostList />
                        </Layout>
                    </RequireAuth>
                } />
                <Route path="/settings" element={
                    <RequireAuth>
                        <ProtectedRoute requiredPermission="settings">
                            <Layout>
                                <Settings />
                            </Layout>
                        </ProtectedRoute>
                    </RequireAuth>
                } />
                <Route path="/comments" element={
                    <RequireAuth>
                        <ProtectedRoute requiredPermission="comment_list">
                            <Layout>
                                <CommentListPage />
                            </Layout>
                        </ProtectedRoute>
                    </RequireAuth>
                } />
                <Route path="/ai-responses" element={
                    <RequireAuth>
                        <ProtectedRoute requiredPermission="ai_response">
                            <Layout>
                                <AIResponsePage />
                            </Layout>
                        </ProtectedRoute>
                    </RequireAuth>
                } />
                <Route path="/users" element={
                    <RequireAuth>
                        <ProtectedRoute requiredPermission="users_management">
                            <Layout>
                                <Users />
                            </Layout>
                        </ProtectedRoute>
                    </RequireAuth>
                } />
            </Routes>
        </Router>
    );
};

export default App;
